import { useContext, useEffect, useState } from "react";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
import "./studentSearchhistory.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  STUDENT_SEARCH_TAB,
  STUDENT_SEARCH_HISTORY,
  MY_BATCHES_LIST,
} from "utilFunctions/Constants/urlConstants";
import { Card, Label } from "reactstrap";
import styled from "styled-components";
import { Checkbox, Select } from "antd";
import type { CheckboxProps } from "antd";
import StudentSearchHistoryTable from "Pages/StudentHistory/StudentSearchHistoyTable";
import { Tabs } from "antd";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
import { useNavigate } from "react-router-dom";
const CardStyled = styled<any>(Card)`
  padding: 0px 20px;
  background: #fff;
  margin-top: 16px;
  height: ${(props) =>
    props.viewAllComments
      ? "calc(100vh - 130px) !important"
      : !props.isPerformanceVisible
      ? "calc(100vh - 100px) !important"
      : "calc(100vh - 260px) !important"};
`;

export type searchedstudent = {
  [key: string]: any;
  name: string;
  psid: number | string;
  clazz: string;
  stream: string;
  acadToClassMap?: [];
  selectedYear?: {
    value: "";
    label: "";
  } | null;
};

const StudentSearchHistoryMain = () => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [selectedBatch, setSelectedBatch] = useState<any>(null);
  const [mainactiveTab, setMainActiveTab] = useState<any>("0");
  const [tableData, setTableData] = useState<any>([]);
  const [tabData, setTabData] = useState<any>([]);
  const { screen }: any = useWindowSize();
  const [BATCHData, setBATCHData] = useState<any>([]);
  const ToastDispatch = useContext<any>(ToastContextDispatch);

  const { makeRequest: GetStudentData, loading: isTabLoader } = useGetApi(
    (res) => {
      if (res.data) {
        setTabData(res.data);
      } else {
        setTabData([]);
      }
    },
    (error) => {
      console.log(error);
    }
  );
  const {
    makeRequest: GetSearchData,
    loading: isHistoryLoader,
    responseData: historyDataBP,
  } = useGetApi(
    (data) => {
      if (data["data"]) {
        setTableData(data["data"]);
      } else {
        setTableData([]);
      }
    },
    (error) => {
      setTableData([]);
      console.log("datata====", error);
    }
  );
  const { makeRequest: GetBATCHDATA, loading: isBatchLoader } = useGetApi(
    (data) => {
      if (data["data"]) {
        setBATCHData(
          data["data"].map((el: any) => {
            return {
              label: el.batchName,
              value: el.batchId,
            };
          })
        );
      } else {
        setBATCHData([]);
      }
    },
    (error) => {
      setBATCHData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    if (userInfo && userInfo.employeeId) {
      let url = BASE_URL + MY_BATCHES_LIST;
      url = url + "?facultyId=" + userInfo?.employeeId;
      GetBATCHDATA(url);
      GetSearchData(`${BASE_URL + STUDENT_SEARCH_HISTORY}`);
      pushToDataLayerForGTM({
        event: "view_my_students_list",
        user_role: userInfo?.fexRole,
        branch_selected: userInfo?.branch ?? null,
        batch_selected: null,
        sort_applied: null,
      });
    }
  }, [userInfo]);
  useEffect(() => {
    if (BATCHData && BATCHData != null && BATCHData.length) {
      const id = BATCHData[0]?.value;
      setSelectedBatch(id);
      GetStudentData(`${BASE_URL + STUDENT_SEARCH_TAB}` + "?batchId=" + id);
    }
  }, [BATCHData]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    document.body.classList.add("noOverflow");
    return () => {
      document.body.classList.remove("noOverflow");
    };
  }, []);

  const onChange: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked) {
      if (mainactiveTab == "1") {
        const newTabdata = tableData.filter(
          (el: any) => el.lastCommentFacId == userInfo.id
        );
        if (newTabdata && newTabdata.length) {
          setTableData(() => [...newTabdata]);
        } else {
          setTableData([]);
        }
      }
    } else {
      if (mainactiveTab == "1") {
        setTableData(() => [...historyDataBP["data"]]);
      }
    }
  };

  const operationsHistory = (
    <Checkbox onChange={onChange}>My Comments</Checkbox>
  );
  const operationsMyStudent = (
    <div className="d-flex flex-row justify-content-start align-items-center">
      {!isBatchLoader && selectedBatch != null && (
        <>
          {" "}
          <Label className="batch-label-filter-style">Batch: </Label>
          <Select
            size={["xxl", "xl", "lg"].includes(screen) ? "middle" : "small"}
            style={{
              width: "250px",
            }}
            showSearch
            placeholder="Batch"
            options={BATCHData}
            optionFilterProp={"label"}
            onChange={(selected: any) => {
              handleSelectedBatch("batchId", selected);
            }}
            defaultValue={selectedBatch}
          />
        </>
      )}
    </div>
  );

  const maintabs = [
    {
      key: "0",
      label: "My Students",
      value: "0",
      children: (
        <>
          <div>
            <StudentSearchHistoryTable
              tableName={"My Students"}
              data={tabData}
              loading={isTabLoader}
              screen={screen}
            >
              {operationsMyStudent}
            </StudentSearchHistoryTable>
          </div>
        </>
      ),
    },
    {
      key: "1",
      label: "History",
      value: "1",
      children: (
        <div>
          <StudentSearchHistoryTable
            tableName={"History"}
            data={tableData}
            loading={isHistoryLoader}
            screen={screen}
          >
            {operationsHistory}
          </StudentSearchHistoryTable>
        </div>
      ),
    },
  ];
  //   const [component, setComponent] = useState<any>(maintabs[0]);

  const handleSelectedBatch = (batchId: any, selected: any) => {
    setSelectedBatch(selected);
    GetStudentData(`${BASE_URL + STUDENT_SEARCH_TAB}` + "?batchId=" + selected);
  };

  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "mainContainerOfPerformance"
          : "mainContainerOfPerformanceMB"
      }
    >
      <HeadersComponent
        cardTitle={"Student Performance"}
        backButtonHandler={(e: any) => {
          e.preventDefault();
          navigate(-1);
        }}
      ></HeadersComponent>
      <CardStyled>
        {["xxl", "xl", "lg"].includes(screen) ? (
          <div>
            <div>
              <Tabs
                centered={false}
                tabBarExtraContent={
                  mainactiveTab == "1" ? operationsHistory : operationsMyStudent
                }
                defaultActiveKey={mainactiveTab}
                onChange={(tab: any) => {
                  setMainActiveTab(tab);
                  if (tab === "0") {
                    pushToDataLayerForGTM({
                      event: "view_my_students_list",
                      user_role: userInfo?.fexRole,
                      branch_selected: userInfo?.branch ?? null,
                      batch_selected: selectedBatch ?? null,
                      sort_applied: null,
                    });
                  }
                }}
                items={maintabs}
                className="fontSizeTab"
              ></Tabs>
            </div>
          </div>
        ) : (
          <>
            {/* <div className="selectDiv">
              <Radio.Group
                options={maintabs}
                defaultValue={mainactiveTab}
                optionType="button"
                onChange={(e: any) => {
                  console.log("selected", e);
                  const comp = maintabs.filter(
                    (el: any) => el.key == e.target.value
                  );
                  setComponent(comp[0]);
                  setMainActiveTab(e.target.value);
                }}
              />
              {mainactiveTab == "0" && tabData && tabData.length > 0 ? (
                <div className="d-flex flex-column">
                  <div>{operationsMyStudent}</div>
                  {tabData && tabData.length > 0 ? component.children : null}
                </div>
              ) : tableData && tableData.length > 0 ? (
                <div className="d-flex flex-column">
                  <div>{operationsHistory}</div>
                  {tableData && tableData.length > 0
                    ? component.children
                    : null}
                </div>
              ) : null}
            </div> */}
            <div>
              <div>
                <Tabs
                  centered={false}
                  defaultActiveKey={mainactiveTab}
                  onChange={(tab: any) => {
                    setMainActiveTab(tab);
                    if (tab === "0") {
                      pushToDataLayerForGTM({
                        event: "view_my_students_list",
                        user_role: userInfo?.fexRole,
                        branch_selected: userInfo?.branch ?? null,
                        batch_selected: selectedBatch ?? null,
                        sort_applied: null,
                      });
                    }
                  }}
                  items={maintabs}
                  className="fontSizeTab"
                ></Tabs>
              </div>
            </div>
          </>
        )}
      </CardStyled>
    </div>
  );
};
export default StudentSearchHistoryMain;
